module.exports = __webpack_public_path__ + "img/brand1.c32479a0.png";